(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle-product-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bundle-block')) {
    customElements.define('bundle-block', class BundleBlock extends HTMLElement {
        connectedCallback() {
            this.productForm = document.getElementById(this.dataset.productFormId);
            this.variantInput = this.productForm ? this.productForm.querySelector('input[name="id"]') : null;
            this.submitButton = this.querySelector('[data-bundle-submit]');
            this.items = Array.from(this.querySelectorAll('[data-bundle-item]'));
            this.secondaryChooseButtons = Array.from(document.querySelectorAll('[data-bundle-choose-btn]:not([disabled])'));
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.mainOptionsAvailabilityChangedHandler = this.handleMainOptionsAvailabilityChanged.bind(this);

            this.bindItemActivation();
            this.initProductPicker();
            this.addEventListener('bundle:main-options-availability-changed', this.mainOptionsAvailabilityChangedHandler);
            this.submitButton.addEventListener('click', this.handleSubmit.bind(this))
            this.refreshSubmitButtonState();
        }

        bindItemActivation() {
            this.items.forEach((item) => {
                const header = item.querySelector('[data-bundle-item-header]');
                if (!header) return;

                header.addEventListener('click', () => this.setActiveItem(item));
                header.addEventListener('keydown', (event) => {
                    if (event.key !== 'Enter' && event.key !== ' ') return;
                    event.preventDefault();
                    this.setActiveItem(item);
                });
            });
        }

        setActiveItem(activeItem) {
            this.items.forEach((item) => {
            const content = item.querySelector('[data-bundle-item-content]');
            const isActive = item === activeItem;

            item.classList.toggle('bundle-block__item--selected', isActive);
            item.setAttribute('aria-expanded', isActive ? 'true' : 'false');

            if (content) {
                content.setAttribute('aria-hidden', isActive ? 'false' : 'true');
            }
            });
            this.refreshSubmitButtonState();
        }

        handleMainOptionsAvailabilityChanged(event) {
            if (!event.target?.matches('.main-bundle-block__options')) return;
            this.refreshSubmitButtonState();
        }

        disableSubmitButton() {
            if (!this.submitButton) return;
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButton.setAttribute('aria-disabled', 'true');
        }

        enableSubmitButton() {
            if (!this.submitButton) return;
            this.submitButton.removeAttribute('disabled');
            if (!this.submitButton.classList.contains('loading')) {
                this.submitButton.removeAttribute('aria-disabled');
            }
        }

        refreshSubmitButtonState() {
          const selectedItem = this.items.find((item) => item.classList.contains('bundle-block__item--selected'));
          const mainBundleOptions = selectedItem.querySelector('.main-bundle-block__options');
          
          if (mainBundleOptions?.classList.contains('bundle-block__item--unavailable')) {
              this.disableSubmitButton();
              return;
          }

          this.enableSubmitButton();
        }

        initProductPicker() {

            this.secondaryChooseButtons.forEach((button) => {
                button.addEventListener('click', () => this.selectSecondaryProduct(button, button.dataset.bundleProductKey, button.dataset.bundleArea));
            });

            if (this.secondarySearch) {
                this.secondarySearch.addEventListener('input', () => {
                    const query = this.secondarySearch.value.trim().toLowerCase();
                    this.secondaryRows.forEach((row) => {
                        const matches = !query || row.dataset.bundleSecondaryProductTitle.includes(query);
                        row.hidden = !matches;
                    });
                });
            }
        }

        selectSecondaryProduct(btn, productKey, bundleArea) {
            const panels = this.querySelectorAll(`[data-bundle-slot="${bundleArea}"] .bundle-block__secondary-panel`);
            const placeholder = this.querySelector(`[data-bundle-placeholder="${bundleArea}"]`);
            const modal = btn.closest('modal-dialog');
            const panelMarker = this.querySelector(`[data-bundle-marker="${bundleArea}"]`)
            let fondPanel = false;

            panels.forEach(panel => {
                panel.classList.add('hidden');
                if(panel.dataset.bundleProductKey === productKey) {
                    panel.classList.remove('hidden');
                    fondPanel = true;
                }
            });
            if(fondPanel){ 
                placeholder.classList.add('hidden');
                panelMarker.querySelector('.bundle-block__secondary-step')?.classList.add('hidden')
                panelMarker.querySelector('.bundle-block__secondary-bullet')?.classList.remove('hidden')
            }

            modal.hide();
        }

        handleSubmit(){
            if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.submitButton.hasAttribute('disabled')) return;
            this.handleErrorMessage();
            this.submitButton.setAttribute('aria-disabled', true);
            this.setButtonLoading();
            const selectedItem = this.items.find((item) => item.classList.contains('bundle-block__item--selected'));
            if (!selectedItem) {
                this.handleErrorMessage('No bundle selected');
                this.setButtonLoading(true);
                this.submitButton.removeAttribute('aria-disabled');
                return;
            }

            const bundleVariants = Array.from(selectedItem.querySelectorAll('[data-bundle-variant][data-bundle-quantity]'))
                .filter((bundleOptions) => !bundleOptions.closest('.hidden'))
                .map((bundleOptions) => {
                    const quantity = Number.parseInt(bundleOptions.dataset.bundleQuantity || '1', 10);
                    return {
                        id: bundleOptions.dataset.bundleVariant,
                        quantity: Number.isNaN(quantity) || quantity < 1 ? 1 : quantity
                    };
                })
                .filter((bundleOption) => bundleOption.id);

            if (!bundleVariants.length) {
                this.handleErrorMessage('No bundle variants selected');
                this.setButtonLoading(true);
                this.submitButton.removeAttribute('aria-disabled');
                return;
            }

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.body = JSON.stringify({
                items: bundleVariants
            });

            if (this.cart) {
                const payload = JSON.parse(config.body);
                payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
                payload.sections_url = window.location.pathname;
                this.cart.setActiveElement(document.activeElement);
                config.body = JSON.stringify(payload);
            }

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        this.handleErrorMessage(response.description);
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    this.error = false;
                    this.cart.renderContents(response);
                })
                .catch((error) => {
                    this.error = true;
                    console.error(error);
                })
                .finally(() => {
                    this.setButtonLoading(true);
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                });

        }

        setButtonLoading(remove=false){
            if (remove) {
                this.submitButton.classList.remove('loading');
                this.submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
                return;
            }
            this.submitButton.classList.add('loading');
            this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }

        formatMoney(cents) {
            const rawValue = Number(cents) / 100;

            try {
            return new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: this.dataset.currencyCode
            }).format(rawValue);
            } catch (error) {
            return this.dataset.initialVariantPrice || '';
            }
        }
        handleErrorMessage(errorMessage = false) {
            this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}

if (!customElements.get('bundle-options')) {
    customElements.define('bundle-options', class BundleOptions extends HTMLElement {
        connectedCallback() {
            this.optionSelects = Array.from(this.querySelectorAll('[data-bundle-option-select]'));
            this.variantsNode = this.querySelector('[data-bundle-variants]');
            this.variants = this.variantsNode ? JSON.parse(this.variantsNode.textContent) : [];

            this.bindOptionSelects();
            this.handleOptionChange();
            if (this.isPrimaryMainBundleOptions()) {
              this.mainVariantChangedHandler = this.handleMainVariantChanged.bind(this);
              document.addEventListener('product:variant:changed', this.mainVariantChangedHandler);
            }
        }

        disconnectedCallback() {
            if (this.mainVariantChangedHandler) {
                document.removeEventListener('product:variant:changed', this.mainVariantChangedHandler);
            }
        }

        isPrimaryMainBundleOptions() {
            return this.classList.contains('main-bundle-block__options')
        }

        bindOptionSelects() {
            if (!this.optionSelects.length) return;

            this.optionSelects.forEach((select) => {
                select.addEventListener('change', () => this.handleOptionChange());
            });
        }

        handleMainVariantChanged(event) {
            const variant = event.detail?.variant;

            if (!variant?.id || !Array.isArray(variant.options)) return;

            const sortedSelects = [...this.optionSelects].sort(
                (a, b) => Number(a.dataset.bundleOptionIndex) - Number(b.dataset.bundleOptionIndex)
            );

            sortedSelects.forEach((select, index) => {
                const nextValue = variant.options[index];
                if (typeof nextValue === 'string') {
                    select.value = nextValue;
                }
            });

            this.dataset.bundleVariant = variant.id;
            this.classList.toggle('bundle-block__item--unavailable', !variant.available);
            this.dispatchMainAvailabilityChanged();
        }

        handleOptionChange() {
            const selectedOptions = this.optionSelects
            .sort((a, b) => Number(a.dataset.bundleOptionIndex) - Number(b.dataset.bundleOptionIndex))
            .map((select) => select.value);

            const matchedVariant = this.variants.find((variant) => {
                if (!Array.isArray(variant.options) || variant.options.length !== selectedOptions.length) return false;
                return variant.options.every((optionValue, index) => optionValue === selectedOptions[index]);
            });

            if (!matchedVariant) {
                return;
            }
            this.classList.toggle('bundle-block__item--unavailable', !matchedVariant.available);
            this.dataset.bundleVariant = matchedVariant.id
            this.dispatchMainAvailabilityChanged();
        }

        dispatchMainAvailabilityChanged() {
            if (!this.isPrimaryMainBundleOptions()) return;
            this.dispatchEvent(new CustomEvent('bundle:main-options-availability-changed', {
                bubbles: true
            }));
        }
    })

}
  } catch(e) { console.error(e); }
})();

})();
